import { render, staticRenderFns } from "./Сounterparties.vue?vue&type=template&id=55e2ab9d&"
import script from "./Сounterparties.vue?vue&type=script&lang=js&"
export * from "./Сounterparties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports